import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import App from './App.vue';
import router from './router';
import './registerServiceWorker';

import LocatorPluginInterface from '@/locator';

Vue.config.productionTip = false;

Vue.use(LocatorPluginInterface);

// noinspection JSUnusedGlobalSymbols
new Vue({
  router,
  render: (h) => h(App),
  vuetify,
}).$mount('#app');
